import { render, staticRenderFns } from "./UnreadConversations.vue?vue&type=template&id=5809e94b&"
import script from "./UnreadConversations.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UnreadConversations.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports